import ROUTES from "./constants";
import { Route, Routes as RouterRoutes } from "react-router-dom";
import ErrorBoundary from "../containers/errors";
import LayoutComponent from "../containers/layouts";
import Home from "../pages/home";
import Services from "../pages/services";
import ListingService from "../pages/listing";
import SignUp from "../pages/vendor/signUp";
import SignIn from "../pages/vendor/signIn";
import Price from "../pages/pricing";
import VendorDashboard from "../pages/admin-viewer/dashboard";
import DashboardLayout from "../containers/dashboardLayout";
import AddListing from "../pages/admin-viewer/lisntingManagment/addLising";
import ManageListing from "../pages/admin-viewer/lisntingManagment/manageListing";

const RoutesComponent: React.FC = () => {
  return (
    // <ErrorBoundary>
    <RouterRoutes>
      {/* Guest User Routes */}
      <Route
        path={ROUTES.Home}
        element={
          <LayoutComponent>
            <Home />
          </LayoutComponent>
        }
      />

      <Route
        path={ROUTES.Listing}
        element={
          <LayoutComponent>
            <ListingService />
          </LayoutComponent>
        }
      />
      <Route
        path={ROUTES.SignUp}
        element={
          <LayoutComponent>
            <SignUp />
          </LayoutComponent>
        }
      />
      <Route
        path={ROUTES.SignIn}
        element={
          <LayoutComponent>
            <SignIn />
          </LayoutComponent>
        }
      />
      <Route
        path={ROUTES.Price}
        element={
          <LayoutComponent>
            <Price />
          </LayoutComponent>
        }
      />

      <Route
        path={ROUTES.vendorDashboard}
        element={
          <DashboardLayout>
            <VendorDashboard />
          </DashboardLayout>
        }
      />
      <Route
        path={ROUTES.manageListing}
        element={
          <DashboardLayout>
            <ManageListing />
          </DashboardLayout>
        }
      />
      <Route
        path={ROUTES.addListing}
        element={
          <DashboardLayout>
            <AddListing />
          </DashboardLayout>
        }
      />
      <Route
        path={ROUTES.Services}
        element={
          <LayoutComponent>
            <Services />
          </LayoutComponent>
        }
      />
    </RouterRoutes>
    // </ErrorBoundary>
  );
};
export default RoutesComponent;
